export const animatedHeader = (function() {
	var docElem = document.documentElement,
		header = document.querySelector( '.header' ),
		didScroll = false,
		stickyOn = 100,
		prevScrollY = 0,
		threshold = 48;

	if (!header) {
		return;
	}

	setTimeout(function() {
		window.addEventListener( 'scroll', function( event ) {
			if( !didScroll ) {
				didScroll = true;
				setTimeout( scrollPage, 0 );
			}
		}, false );
	}, 1500) // Delay to allow the page to load before attaching scroll event

	function scrollPage() {
		var sy = scrollY();
		var diff = Math.abs(prevScrollY - sy);
		
		if (diff > threshold) {
			if (prevScrollY > sy)
				header.className = ('header');
			else if (sy >= stickyOn)
				header.className = ('header header--sticky');
			
			prevScrollY = sy;
		}
		
		didScroll = false;
	}

	const scrollY = () => window.pageYOffset || docElem.scrollTop;
})();

export default animatedHeader;